"use strict";

exports.__esModule = true;
exports.isImageCard = void 0;
var isImageCard = function isImageCard(columns) {
  return columns.find(function (item) {
    if (!item) return false;
    var description = item.description,
      image = item.image,
      link = item.link,
      link2 = item.link2,
      link3 = item.link3;
    if (!description) return false;
    var mainHeading = description.mainHeading,
      paragraph = description.paragraph,
      sectionHeading = description.sectionHeading;
    return image && !mainHeading && !paragraph && !sectionHeading && !(link != null && link.url) && !(link2 != null && link2.url) && !(link3 != null && link3.url);
  });
};
exports.isImageCard = isImageCard;